const AbstractCloverRequestRecord = require('./AbstractCloverRequestRecord');

class CloverDeviceVerifyConnectivityRequestRecord extends AbstractCloverRequestRecord {
    constructor() {
        // @link https://docs.clover.com/reference/ping_device_get
        const url = '/connect/v1/device/ping/';
        super(
            'GET',
            url
        );
    }
}

module.exports = CloverDeviceVerifyConnectivityRequestRecord;
